import { routerGetCall } from '../../axios';

export const clientCachePoliciesUrl = `/accounts/client-policies`;

const getClientsPolicies = (state, params) => {
  const url = `/accounts/viewPortfolio/insurance`;
  return routerGetCall(state, url, params);
};
export default { getClientsPolicies };
